import React from "react";

import PRISMA from "../../assets/images/PRISMA.jpg";
import PRISPEK from "../../assets/images/PRISPEK.png";
import SPEKTRA from "../../assets/images/SPEKTRA.png";
import { useWindowDimensions } from "../../hooks";
import { Bookings } from "../../config";
import { AboutCard } from "..";

export const AboutSection: React.FC<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>
> = React.memo((props) => {
  const { width } = useWindowDimensions();
  return (
    <section className="landing__about" {...props}>
      <AboutCard
        readMore
        width={width}
        logo={PRISPEK}
        title="Prispek"
        about={[
          {
            key: 0,
            paragraph: `Prispek Consulting comprises of three entities functioning strongly, both collectively and independently, to benefit you. Prisma Accountants & Spektra Financial Services form a strong bond with Prispek Consulting making it possible for clients to receive professional one-stop financial advice and service. Prispek Consulting conducts seminars and briefings to keep you informed about economic updates and relevant changes in tax legislation. One appointment is all it takes to discuss your tax, insurance and investment portfolio and any effects changes might have on your portfolio.`,
          },
        ]}
      />
      <AboutCard
        readMore
        width={width}
        logo={SPEKTRA}
        title="Spektra"
        contactLink={Bookings.Spektra}
        about={[
          {
            key: 1,
            paragraph: `Christo Viljoen started giving financial advice as an agent with Fedsure Life in 1996.  He realised however that in order to give the best advice for the benefit of every client, he has to become an independent advisor with no restrictions placed on his advice by insurance companies or banks.  Spektra Financial Services was registered in 1998 and together with Prisma Accountants started giving unbiased advice to their clients.`,
          },
        ]}
      />
      <AboutCard
        readMore
        width={width}
        logo={PRISMA}
        title="Prisma"
        contactLink={Bookings.Prisma}
        about={[
          {
            key: 2,
            paragraph:
              "Prisma Accountants is a professional accounting firm registered at the South African Institute of Professional Accountants situated in Magalieskruin in the Northern suburbs of Pretoria. Prisma Accountants act as a registered Tax Practitioner on behalf of the South African Revenue services (SARS). Prisma Accountants celebrated 22 years of existence in 2020 with great expectation and enthusiasm about our future.",
          },
        ]}
      />
    </section>
  );
});
